import { memo } from 'react';
import { Dialog } from 'react-aria-components';

import { Modal, ModalOverlay, ModalOverlayProps } from '@/components/core';

import { RerunAgentRuns } from './RerunAgentRuns';

export type RerunAgentRunsModalProps = ModalOverlayProps & {
  progress: number;
};

const IRerunAgentRunsModal = ({ progress, ...rest }: RerunAgentRunsModalProps) => {
  return (
    <ModalOverlay {...rest}>
      <Modal>
        <Dialog className="outline-none">
          <RerunAgentRuns className="w-[25rem] p-4" progress={progress} />
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};

export const RerunAgentRunsModal = memo(IRerunAgentRunsModal) as typeof IRerunAgentRunsModal;
